// extracted by mini-css-extract-plugin
export var center = "_40-2";
export var clickableRow = "_40-5";
export var expandedRow = "_40-7";
export var hoverable = "_40-4";
export var left = "_40-1";
export var right = "_40-3";
export var row = "_40-0";
export var selectedRow = "_40-6";